"use client";

import WhatsAppIcon from "@/components/ui/whatsappicon";
import posthog from "posthog-js";
import { whatsappLinkWithText } from "@/app/jafeth-link";

interface InlineWhatsAppButtonProps {
  result: { message?: string } | null;
  state: string;
  carrierId: string;
}

const DEFAULT_MESSAGE =
  "Hola, estaba usando el chat de jaro.mx y necesito ayuda con un flete.";

/**
 * Escape hatch (#486): the concierge chat has no human takeover — every handoff
 * is a WhatsApp deep link to the Kapso-managed line, prefilled with the
 * conversation's context so the follow-up picks up warm.
 */
export function InlineWhatsAppButton({
  result,
  state,
  carrierId,
}: InlineWhatsAppButtonProps) {
  if (state === "partial-call" || state === "input-streaming" || state === "call") {
    return <div className="my-2 h-11 animate-pulse rounded-lg bg-gray-100" />;
  }

  const message = result?.message?.trim() || DEFAULT_MESSAGE;

  return (
    <a
      href={whatsappLinkWithText(message)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() =>
        posthog.capture("chat_whatsapp_handoff_click", { carrier_id: carrierId })
      }
      className="my-2 flex w-full items-center justify-center gap-2 rounded-lg bg-green-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-green-700"
    >
      <WhatsAppIcon className="h-4 w-4 shrink-0" />
      Continuar por WhatsApp
    </a>
  );
}
